import React from 'react';

export function FieldLabel({ k, children }) {
  return (
    <label className="text-eyebrow mb-1 block flex items-center gap-2">
      <span className="text-ink">{children}</span>
      <span className="text-ink-dim normal-case tracking-normal">·</span>
      <span className="text-ink-dim normal-case tracking-normal lowercase font-mono text-[10px]">{k}</span>
    </label>
  );
}
